import ATranslation from "aloha-vue/src/ATranslation/ATranslation";

import UIReadOnlyMixin from "../../UIReadOnlyMixin";

import DataAPI from "./compositionAPI/DataAPI";
import ModelAPI from "./compositionAPI/ModelAPI";

// @vue/component
export default {
  name: "UiRouterLinkConfigReadOnly",
  components: {
    ATranslation,
  },
  mixins: [
    UIReadOnlyMixin,
  ],
  setup(props) {
    const {
      hasModelParam,
      hasModelQuery,
    } = ModelAPI(props);

    const {
      currentRouteText,
      targetsKeyById,
    } = DataAPI(props);

    return {
      currentRouteText,
      hasModelParam,
      hasModelQuery,
      targetsKeyById,
    };
  },
};
